<template>
  <button
    ref="button"
    type="button"
    :class="['btn-db copy-link', {'is-visible-done': isVisibleDone, 'is-disabled': disabled}]"
    :uid="_uid"
    :data-clipboard-text="url"
    :disabled="disabled"
    @click="handleClick"
    @mouseleave="reset">
    <slot>
      <i :class="settings.icon"/>
      <span :class="{'done-tooltip': isDone}">{{label}}</span>
    </slot>
  </button>
</template>

<script>
import ClipboardJS from 'clipboard'

let clipboard = null
let timer = null
export default {
  name: 'ButtonClipboard',
  props: {
    options: { type: Object },
    text: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      isVisibleDone: false,
      isDone: false,
      settings: this.OPTIONS()
    }
  },
  methods: {
    OPTIONS () {
      return {
        icon: 'icon-db link round',
        label: this.L10n('copy-link-url'),
        done: this.L10n('copied')
      }
    },
    parserOptions () {
      this.settings = this.$_.merge(this.OPTIONS(), this.options)
    },
    handleClick () {
      this.isDone = true
      this.reset()
      this.isVisibleDone = true
      timer = setTimeout(this.reset, 3000)
    },
    reset () {
      this.isVisibleDone = false
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    }
  },
  computed: {
    url () {
      return this.text || window.location.href
    },
    label () {
      return this.isDone
        ? this.settings.done
        : this.settings.label
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.parserOptions()
      if (this.$refs.button) {
        clipboard = new ClipboardJS(this.$refs.button)
      } else {
        // eslint-disable-next-line
        console.warn('not correct init clipboard button -> _uid:', this._uid)
      }
    })
  },
  beforeDestroy () {
    this.parserOptions()
    this.reset()
    this.isDone = false
    if (clipboard) clipboard.destroy()
  }
}
</script>
